<template>
    <div class="min-h-screen" :class="[$page.props.settings.site_name == 'Zilliqa' ? 'bg-black' : 'bg-gray-900', ]">
        <div class="max-w-lg px-4 md:px-0 gap-8 sm:justify-center items-center pt-6 sm:pt-0 p-0 m-auto">

            <div>
                <div>
                    <slot name="logo" />
                </div>

                <div class="w-full px-6 py-4 bg-white shadow-md overflow-hidden rounded-md">
                    <slot />
                </div>
            </div>

        </div>

    </div>

</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/outline'

export default {
    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        ChevronDownIcon
    }}

</script>
